import BaseModel from '../BaseModel';

export default class PublicToken extends BaseModel {
  static entity = 'publicTokens';

  static primaryKey = 'id';

  static fields() {
    return {
      candidateId: this.attr(null),
      id: this.attr(null),
      token: this.attr(null),
      url: this.attr(null),
    };
  }

  static apiConfig = {
    actions: {
      generate(id) {
        return this.post(`candidates/${id}/public-token`);
      },
    },
  }
}
